//Material
import { Grid, Skeleton, Stack, Typography } from "@mui/material";
//Interfaces and Types
import { TUserProfileMainInformationProps } from "../../types/UserProfile";
//Components
import ImageUserProfilePicture from "@/Layouts/components/ImageUserProfilePicture";
//Icons
import IconHover from "@/User/assets/icons/person-circle-hov.svg";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

export default function UserProfileMainInformation({
	isLoading,
	profilePicture,
	hov,
	fullName,
	position,
	handleHov,
	handleClick,
}: Readonly<TUserProfileMainInformationProps>) {
	return (
		<Grid container justifyContent={"center"} className={"userprofile-container top-section"}>
			<Grid
				container
				item
				xs={12}
				md={7}
				direction={"column"}
				justifyContent={"center"}
				className={"userprofile-container top-section"}
			>
				<Grid container item xs={12} direction="row" alignContent={"center"} alignItems={"center"} columnSpacing={2}>
					<Grid item xs={2} pl={"0px !important"}>
						<Stack className="group/user-profile-update-container" position={"relative"} mt={"-40px"}>
							{isLoading ? (
								<Stack className="absolute">
									<Skeleton variant="circular" width={100} height={100} />
								</Stack>
							) : (
								<>
									<Stack className="absolute">
										<ImageUserProfilePicture
											handleClick={handleClick}
											context="edit"
											onMouseLeave={() => handleHov(false)}
											onMouseOver={() => handleHov(true)}
											widthImgHolder={"100px"}
											className={`user-profile-picture ${
												hov ? "user-profile-picture-color1" : "user-profile-picture-color2"
											}`}
											src={hov ? profilePicture ?? IconHover : profilePicture}
										/>
									</Stack>
									<Stack className="absolute">
										<Grid item className={"user-img-container !pr-0"} onClick={handleClick}>
											<Grid
												className={"img-layer invisible group-hover/user-profile-update-container:visible"}
											></Grid>
											<PhotoCameraIcon
												className="
													invisible group-hover/user-profile-update-container:visible
													absolute
													mt-[33px]
													ml-[28px]
													cursor-pointer
													text-white
													!w-[43px]
													!h-[40px]
												"
												onClick={handleClick}
											/>
										</Grid>
									</Stack>
								</>
							)}
						</Stack>
					</Grid>
					<Grid item xs={true} className="usr-copy-container !max-w-[600px]">
						<Typography className={"fullname-copy"}>{isLoading ? <Skeleton /> : fullName}</Typography>
						<Typography className={"position-copy"}>{isLoading ? <Skeleton /> : position}</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
